import { render, staticRenderFns } from "./approvalForm.vue?vue&type=template&id=efb12650"
import script from "./approvalForm.vue?vue&type=script&lang=js"
export * from "./approvalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports